// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__-7LQR","subtitle":"styles_subtitle__1Pf2h"};